import { WebPage } from "~/components/layout/WebPage";
import { QENDO_LINKS } from "~/constants/environment";

export default function Exercise() {
    return <WebPage title="Exercise" uri={QENDO_LINKS.exercise} />;
}
